export default {
  LOAD_CYCLE_OVERVIEW_PAGE_START: 'LoadCycleOverviewPageStart',
  LOAD_CYCLE_OVERVIEW_PAGE_END: 'LoadCycleOverviewPageEnd',
  SELECT_CYCLE_OVERVIEW_PAGE_TAB: 'SelectCycleOverviewPageTab'
};